
(function() {
  
  angular.module('PrintQueuePropertiesProvider', [])
  
  .factory('PrintQueuePropertiesModel', ['$q', '$http', 'TenantListService', function( $q, $http, TenantListService) {
    return function(data) {
      var PrintQueuePropertiesModel = {
        // name: data.name,
        // signId: data.signId,
        // active: data.active,
        // autoInstall: data.autoInstall,
        // mobilePrint: data.mobilePrint,
        // global: data.global,
        // autoUpdate: data.autoUpdate,
        // autoRemove: data.autoRemove,
        // defaultMono: data.defaultMono,
        // defaultDuplex: data.defaultDuplex,
        // alwaysReprint: data.alwaysReprint,
        hasGroupsWithExclusiveAccess: false,
        groupList: null,
        id: setId(data._links.self.href),
        // version: data.version,
        // embedded: data._embedded,
        // links: data._links,
        info: data
      };

      function setId (selfLink) {
        return selfLink.split('queues/')[1];
      }

      PrintQueuePropertiesModel.groups_ADD = function (url, groups) {
        var deferred = $q.defer()
        
        var dataToSend = {
          groups: groups || []
        };
        
        $http.post(url, dataToSend).then(function(response) {
          deferred.resolve(response);
        }).catch(function(error) {
          deferred.reject(error);
        });
        return deferred.promise;
      }

      PrintQueuePropertiesModel.groups_REMOVE = function (url, groups) {
        var deferred = $q.defer();
        
        var body = {
          headers: { "Content-Type": "application/json" },
          data: { 
            groups: groups || []
          }
        }
        
        $http.delete(url, body).then(function(response) {
          deferred.resolve(response)
        }).catch(function(error) {
          deferred.reject(error)
        });
        return deferred.promise;
      }

      PrintQueuePropertiesModel.exclusiveAccess_ADD = function (groups) {
        var dataToSend = {
          groups: groups || []
        };
        var deferred = $q.defer()
        var url = PrintQueuePropertiesModel.info._links['px:groups'].href;
        $http.post(url, dataToSend).then(function(response) {
          deferred.resolve(response);
        }).catch(function(error) {
          deferred.reject(error);
        });
        return deferred.promise;
      }

      PrintQueuePropertiesModel.exclusiveAccess_REMOVE = function (groups) {
        var body = {
          headers: { "Content-Type": "application/json" },
          data: { 
            groups: groups || []
          }
        }
        var url = PrintQueuePropertiesModel.info._links['px:groups'].href;
        var deferred = $q.defer();
        $http.delete(url, body).then(function(response) {
          deferred.resolve(response)
        }).catch(function(error) {
          deferred.reject(error)
        });
        return deferred.promise;
      }

      PrintQueuePropertiesModel.autoInstall_ADD = function (groups) {
        var dataToSend = {
          groups: groups || []
        }
        var url = PrintQueuePropertiesModel.info._links['px:autoInstallGroups'].href;
        var deferred = $q.defer()
        $http.post(url, dataToSend).then(function(response) {
          deferred.resolve(response);
        }).catch(function(error) {
          deferred.reject(error);
        });
        return deferred.promise;
      }

      PrintQueuePropertiesModel.autoInstall_REMOVE = function (groups) {
        var body = {
          headers: { "Content-Type": "application/json" },
          data: { 
            groups: groups || []
          }
        }
        var url = PrintQueuePropertiesModel.info._links['px:autoInstallGroups'].href;
        var deferred = $q.defer();
        $http.delete(url, body).then(function(response) {
          deferred.resolve(response);
        }).catch(function(error) {
          deferred.reject(error);
        });
        return deferred.promise;
      }

      PrintQueuePropertiesModel.defaultForGroup_ADD = function (groups) {
        var deferred = $q.defer()
        var dataToSend = {
          groups: groups || []
        }
        var url = PrintQueuePropertiesModel.info._links['px:defaultForGroups'].href;
        $http.post(url, dataToSend).then(function(response) {
          deferred.resolve(response);
        }).catch(function(error) {
          deferred.reject(error);
        });
        return deferred.promise;
      }

      

      PrintQueuePropertiesModel.deleteExclusiveAccessGroup = function (group) {
        var body = {
          headers: { "Content-Type": "application/json" },
          data: { groups: [group.info._links.self.href] }
        }
        var url = PrintQueuePropertiesModel.info._links['px:groups'].href;
        var deferred = $q.defer();
        $http.delete(url, body).then(function(response) {
          deferred.resolve(response)
        }).catch(function(error) {
          deferred.reject(error)
        });
        return deferred.promise;
      }

      PrintQueuePropertiesModel.deleteDefaultForGroup = function (groups) {
        var deferred = $q.defer()
        var body = {
          headers: { "Content-Type": "application/json" },
          data: { 
            groups: groups || []
          }
        }
        var url = PrintQueuePropertiesModel.info._links['px:defaultForGroups'].href;
        $http.delete(url, body).then(function(response) {
          deferred.resolve(response);
        }).catch(function(error) {
          deferred.reject(error);
        });
        return deferred.promise;
      }

      PrintQueuePropertiesModel.setExclusiveAccessGroup = function (group) {
        var dataToSend = {
          groups: [group.info._links.self.href]
        };
        var deferred = $q.defer()
        var url = PrintQueuePropertiesModel.info._links['px:groups'].href;
        $http.post(url, dataToSend).then(function(response) {
          deferred.resolve(response);
        }).catch(function(error) {
          deferred.reject(error);
        });
        return deferred.promise;
      }

      PrintQueuePropertiesModel.setAutoInstallGroup = function (group) {
        var dataToSend = {
          groups: [group.info._links.self.href]
        }
        var url = PrintQueuePropertiesModel.info._links['px:autoInstallGroups'].href;
        var deferred = $q.defer()
        $http.post(url, dataToSend).then(function(response) {
          deferred.resolve(response);
        }).catch(function(error) {
          deferred.reject(error);
        });
        return deferred.promise;
      }

      PrintQueuePropertiesModel.setDefaultQueueGroup = function (group) {
        var deferred = $q.defer()
        var url = PrintQueuePropertiesModel.info._links['px:defaultForGroups'].href;
        var dataToSend = {
          groups: [group.info._links.self.href]
        }

        $http.post(url, dataToSend).then(function(response) {
          deferred.resolve(response);
        }).catch(function(error) {
          deferred.reject(error);
        });
        return deferred.promise;
      }

      PrintQueuePropertiesModel.deleteExclusiveAccessGroup = function (group) {
        var body = {
          headers: { "Content-Type": "application/json" },
          data: { groups: [group.info._links.self.href] }
        }
        var url = PrintQueuePropertiesModel.info._links['px:groups'].href;
        var deferred = $q.defer();
        $http.delete(url, body).then(function(response) {
          deferred.resolve(response)
        }).catch(function(error) {
          deferred.reject(error)
        });
        return deferred.promise;
      }

      PrintQueuePropertiesModel.deleteAutoInstallGroup = function (group) {
        var body = {
          headers: { "Content-Type": "application/json" },
          data: { groups: [group.info._links.self.href] }
        }
        var url = PrintQueuePropertiesModel.info._links['px:autoInstallGroups'].href;
        var deferred = $q.defer();
        $http.delete(url, body).then(function(response) {
          deferred.resolve(response);
        }).catch(function(error) {
          deferred.reject(error);
        });
        return deferred.promise;
      }

      PrintQueuePropertiesModel.deleteDefaultForGroup = function (group) {
        var deferred = $q.defer()
        var body = {
          headers: { "Content-Type": "application/json" },
          data: { groups: [group.info._links.self.href] }
        }
        var url = PrintQueuePropertiesModel.info._links['px:defaultForGroups'].href;
        $http.delete(url, body).then(function(response) {
          deferred.resolve(response);
        }).catch(function(error) {
          deferred.reject(error);
        });
        return deferred.promise;
      }

      PrintQueuePropertiesModel.changeSetting = function (patch) {
        var url = PrintQueuePropertiesModel.info._links.self.href;
        var deferred = $q.defer()
        $http.patch(url, patch).then(function(response) {
          deferred.resolve(response);
        }).catch(function(error) {
          deferred.reject(error);
        });
        return deferred.promise;
      }

      PrintQueuePropertiesModel.addGroupsToQueue = function (groups) {
        if (groups) {
          var deferred = $q.defer();
          var url = PrintQueuePropertiesModel.info._links['px:groupUpdateRequests'].href;
          $http.post(url, groups).then(function (response) {
            deferred.resolve(response);
          }).catch(function(error) {
            deferred.reject(error);
          });
          return deferred.promise;
        }
      }

      return PrintQueuePropertiesModel;
    }
  }])

  .factory('PrintQueueGroupModel', ['$q', '$http', 'TenantListService', function($q, $http, TenantListService){
    return function (data) {
      var printQueueGroupModel = {
        options: {isSelected: false},
        name: data.name,
        description: data.description,
        queueCount: data.queueCount,
        userCount: data.userCount,
        workstationCount: data.workstationCount,
        autoInstall: false,
        exclusiveAccess: false,
        defaultForGroup: false,
        inUse: data.inUse,
        id: setId(data._links.self.href),
        links: data._links,
        info: data,
        domainOrigin: findProvider(data)
      };


      function setId (selfLink) {
        return selfLink.split('groups/')[1];
      }

      function findProvider (group) {
        var providerType = null;
        switch (group.provider) {
          case 'AZURE_AD':
            providerType = 'azure'
            break
          case 'GOOGLE_GSUITE':
            providerType = 'google'
            break
          default:
            providerType = group.provider.toLowerCase();
        }
        
        function findDirectory (group, providerType) {
          const directories = TenantListService.currentTenant.info._embedded.tenantIdentityProviders.providers[providerType].directories;
        
          let directory = null;
          for (const key in directories) {
            if (directories.hasOwnProperty(key) && directories[key].idp_tenant_identifier === group.directoryId) {
              directory = directories[key];
              break;
            }
          }
          return directory;
        }
        return findDirectory(group, providerType)
      }

      return printQueueGroupModel;
    }
  }])

  .service('PrintQueuePropertiesService', ['$http', '$q', 'PrintQueuePropertiesModel', 'PrintQueueGroupModel',
    function($http, $q, PrintQueuePropertiesModel, PrintQueueGroupModel) {
      

      this.getPrintQueue = function (printQueueUrl){
        var deferred = $q.defer()
        $http.get(printQueueUrl).then(function(printQueue) {
          var printQueue = new PrintQueuePropertiesModel(printQueue.data);

          getQueueGroups(printQueue).then(function(response) {
            printQueue.exclusiveAccessGroups = response.data._embedded.exclusiveAccessGroups._embedded ? response.data._embedded.exclusiveAccessGroups._embedded['px:groupResources'] : [];
            printQueue.autoInstallGroups = response.data._embedded.autoInstallGroups._embedded ? response.data._embedded.autoInstallGroups._embedded['px:groupResources'] : [];
            printQueue.defaultForGroups = response.data._embedded.defaultForGroups._embedded ? response.data._embedded.defaultForGroups._embedded['px:groupResources'] : [];
            deferred.resolve(createGroupList(printQueue))
          }).catch(function(error) {
            deferred.reject(error);
          });
        }).catch(function(error) {
          deferred.reject(error);
        });
        return deferred.promise;
      } 

      this.getQueueGroups = function (printQueue) {
        var deferred = $q.defer();
        getQueueGroups(printQueue).then(function(response) {
          printQueue.exclusiveAccessGroups = response.data._embedded.exclusiveAccessGroups._embedded ? response.data._embedded.exclusiveAccessGroups._embedded['px:groupResources'] : [];
          printQueue.autoInstallGroups = response.data._embedded.autoInstallGroups._embedded ? response.data._embedded.autoInstallGroups._embedded['px:groupResources'] : [];
          printQueue.defaultForGroups = response.data._embedded.defaultForGroups._embedded ? response.data._embedded.defaultForGroups._embedded['px:groupResources'] : [];
          deferred.resolve(createGroupList(printQueue))
        }).catch(function(error) {
          deferred.reject(error);
        });
        return deferred.promise;
      }

      function getQueueGroups (printQueue) {
        var deferred = $q.defer()
        var url = printQueue.info._links['px:queueGroups'].href;
        $http.get(url).then(function(response) {
          deferred.resolve(response);
        }).catch(function(error) {
          deferred.reject(error);
        });
        return deferred.promise;
      }

      function createGroupList (printQueue) {
        var groupList = [];
        // merge 3 list into 1 list, make sure no duplicates,
        Array.prototype.unique = function () {
          var a = this.concat();
          for (var i = 0; i < a.length; ++i) {
            for (var j = i + 1; j < a.length; ++j) {
              if (a[i]._links.self.href === a[j]._links.self.href)
                a.splice(j--, 1);
            }
          }
          return a;
        };
        groupList = groupList.concat(printQueue.exclusiveAccessGroups)
        groupList = groupList.concat(printQueue.autoInstallGroups).unique();
        groupList = groupList.concat(printQueue.defaultForGroups).unique();
        
        
        // make sure correct attributes are set
        for (var i = 0; i < groupList.length; i++) {
          groupList[i] = new PrintQueueGroupModel(groupList[i])
          groupList[i].encodedLink = encodeURIComponent(encodeURIComponent(groupList[i].info._links.self.href));
          groupList[i] = checkGroupQueueSettings(groupList[i], printQueue)
        }

        printQueue.groupList = sortArrayAlphabetical(groupList);
        return printQueue;
      }

      function sortArrayAlphabetical (array) {
        array.sort(function(a, b) {
          var a = a.info.name.toLowerCase();
          var b = b.info.name.toLowerCase();
          if (a < b) return -1;
          if (a > b) return 1;
          return 0;
        })
        return array;
      }

      function checkGroupQueueSettings (group, printQueue) {
        
        angular.forEach(printQueue.exclusiveAccessGroups, function (exclusiveAccessGroup) {
          if (exclusiveAccessGroup._links.self.href === group.info._links.self.href) {
            printQueue.hasGroupsWithExclusiveAccess = true; 
            group.exclusiveAccess = true;
          }
        })
        
        angular.forEach(printQueue.autoInstallGroups, function (autoInstallGroup) {
          if (autoInstallGroup._links.self.href === group.info._links.self.href) {
            group.autoInstall = true;
          }
        })
        
        angular.forEach(printQueue.defaultForGroups, function (defaultForGroup) {
          if (defaultForGroup._links.self.href === group.info._links.self.href) {
            group.defaultForGroup = true;
          }
        })

        return group;
      }

    }
  ])  

})();